module.exports = __webpack_public_path__ + "img/vs-logo-sm.2e90a82b.webp";